module.exports = require('./lib/_stream_duplex.js');



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Prod_web-client/node_modules/readable-stream/duplex-browser.js
// module id = XvLI
// module chunks = 15